import { render, staticRenderFns } from "./EditorPrescription.vue?vue&type=template&id=60f31bdb&scoped=true&"
import script from "./EditorPrescription.vue?vue&type=script&lang=js&"
export * from "./EditorPrescription.vue?vue&type=script&lang=js&"
import style0 from "./EditorPrescription.vue?vue&type=style&index=0&id=60f31bdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f31bdb",
  null
  
)

export default component.exports